import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractAccess } from '../../../models/Entities/Contracts/ContractAccess';

export default function ContractAccessReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    case 'CONTRACT_ACCESS_GETALL_REQUEST': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAccess: true,
          isGettingContractAccessSuccess: false,
          FailGettingContractAccess: false,
          ErrorGettingContractAccess: undefined
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== a.contractId), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_GETALL_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.constractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAccess: false,
          isGettingContractAccessSuccess: true,
          FailGettingContractAccess: false,
          ErrorGettingContractAccess: undefined,
          access: a.contractAccess
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_GETALL_FAILURE': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isGettingContractAccess: false,
          isGettingContractAccessSuccess: false,
          FailGettingContractAccess: true,
          ErrorGettingContractAccess: a.error
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== a.contractId), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_CREATE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractAccess.contractID);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          access: [...(CurrentContract.access || []), a.contractAccess]
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_UPDATE_REQUEST': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractAccess.contractID);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isUpdatingContractAccess: true,
          isUpdatingContractAccessSuccess: false,
          FailUpdatingContractAccess: false,
          ErrorUpdatingContractAccess: undefined
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_UPDATE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractAccess.contractID);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isUpdatingContractAccess: false,
          isUpdatingContractAccessSuccess: true,
          FailUpdatingContractAccess: false,
          ErrorUpdatingContractAccess: undefined,
          access: [...(CurrentContract.access || []).filter((access: ContractAccess) => access.id !== a.contractAccess.id), a.contractAccess]
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_GETBYID_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractAccess.contractID);
      if (CurrentContract) {
        CurrentContract = { ...CurrentContract, access: [...(CurrentContract.access || []).filter((access: ContractAccess) => access.id !== a.contractAccess.id), a.contractAccess] };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_DELETE_REQUEST': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.contractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isDeletingContractAccess: true,
          isDeletingContractAccessSuccess: false,
          FailDeletingContractAccess: false,
          ErrorDeletingContractAccess: undefined
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    case 'CONTRACT_ACCESS_DELETE_SUCCESS': {
      CurrentContract = currentState.list?.find((item: Contract) => item.id === a.constractId);
      if (CurrentContract) {
        CurrentContract = {
          ...CurrentContract,
          isDeletingContractAccess: false,
          isDeletingContractAccessSuccess: true,
          FailDeletingContractAccess: false,
          ErrorDeletingContractAccess: undefined,
          access: [...(CurrentContract.access || []).filter((access: ContractAccess) => access.id !== a.contractAccessId)]
        };
      }
      return { ...currentState, list: CurrentContract ? [...(currentState.list || []).filter((i: Contract) => i.id !== CurrentContract!.id), CurrentContract] : currentState.list };
    }
    default:
      return currentState;
  }
}
